export default "__VITE_ASSET__CFCW$cXp__"